import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.metricData`;
export const INIT = `${SCOPE}/INIT`;

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const INIT_METRIC = `${SCOPE}/INIT_METRIC`;
export const SETUP_METRIC = `${SCOPE}/SETUP_METRIC`;

export const SET_FETCHING = `${SCOPE}/SET_FETCHING`;
export const SET_RESPONSE = `${SCOPE}/SET_RESPONSE`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;
export const SET_CHART_DATA = `${SCOPE}/SET_CHART_DATA`;
export const SET_TOTAL_VALUE = `${SCOPE}/SET_TOTAL_VALUE`
